// eslint-disable-next-line import/prefer-default-export
export const PAGE_SIZE_OPTIONS_DEFAULT = [10, 20, 30];
export const PAGE_SIZE_DEFAULT = 10;
